import React, { useState } from "react";
import { Link } from "react-router-dom";
import { KeyRound, MailCheck } from "lucide-react";
import { ShopLayout } from "../../components/shop/ShopLayout";
import { shopApi, formatApiError } from "../../lib/shopApi";

const inputCls = "w-full bg-[#1C1C1C] border border-[#C9A24B]/20 rounded-xl px-4 py-3.5 focus:outline-none focus:border-[#C9A24B] transition-colors";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await shopApi.post("/account/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err, "Something went wrong — please try again"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <ShopLayout title="Forgot Password | Loctician Carlocs">
      <div className="max-w-sm mx-auto px-5 py-14 md:py-20" data-testid="forgot-password-page">
        <div className="text-center mb-8">
          <KeyRound className="w-9 h-9 text-[#C9A24B] mx-auto mb-4" />
          <h1 className="font-serif text-3xl mb-2">Forgot Password</h1>
          <p className="text-[#F5EFE3]/50 text-sm">Enter your email and we'll send you a reset link.</p>
        </div>

        {sent ? (
          <div className="bg-[#232323] border border-[#C9A24B]/15 rounded-2xl p-6 text-center" data-testid="forgot-success">
            <MailCheck className="w-8 h-8 text-[#C9A24B] mx-auto mb-4" />
            <p className="text-sm text-[#F5EFE3]/80 leading-relaxed mb-5">
              If an account exists for <span className="text-[#C9A24B]">{email}</span>, a reset link is on its way. It expires in 1 hour.
            </p>
            <Link to="/account/login" className="text-[#C9A24B] underline underline-offset-4 text-sm" data-testid="forgot-back-to-login">
              Back to sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-[#232323] border border-[#C9A24B]/15 rounded-2xl p-6 space-y-4">
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="Email" data-testid="forgot-email-input" className={inputCls} />
            {error && <p className="text-red-400 text-sm" data-testid="forgot-error">{error}</p>}
            <button
              type="submit"
              disabled={busy}
              data-testid="forgot-submit-btn"
              className="w-full bg-[#C9A24B] text-[#1C1C1C] py-4 rounded-full text-xs font-bold uppercase tracking-widest hover:-translate-y-0.5 transition-all duration-300 disabled:opacity-50"
            >
              {busy ? "Sending…" : "Send Reset Link"}
            </button>
            <p className="text-center text-[#F5EFE3]/40 text-sm">
              Remembered it? <Link to="/account/login" className="text-[#C9A24B] underline underline-offset-4" data-testid="forgot-login-link">Sign in</Link>
            </p>
          </form>
        )}
      </div>
    </ShopLayout>
  );
};

export default ForgotPasswordPage;
